import React from 'react';
import { Navigation } from '../components/Navigation';
import { SmsHero } from '../components/SmsHero';
import { SmsWhyUs } from '../components/SmsWhyUs';
import { SmsServices } from '../components/SmsServices';
import { SmsFAQ } from '../components/SmsFAQ';
import { Consultation } from '../components/Consultation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
export function SmsPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-689" data-mp="3p1jptjup01lz">
      <Navigation data-id="element-690" data-mp="3g6vkxut14lxp" />

      <main className="pt-[72px]" data-id="element-691" data-mp="3g6c2mczgvvj5">
        {' '}
        {/* Add padding top to account for fixed navigation */}
        <SmsHero data-id="element-692" data-mp="3b93kgcebjrhw" />
        <Consultation data-id="element-693" data-mp="3b9ljfgsd8jti" />
        <SmsWhyUs data-id="element-694" data-mp="3b67huarj0en4" />
        <SmsServices data-id="element-695" data-mp="368o4dd2nk5w8" />
        <SmsFAQ data-id="element-696" data-mp="3697foaxsrw1a" />
        <Consultation data-id="element-697" data-mp="367mkcj3ns92d" />
      </main>

      <Footer data-id="element-698" data-mp="36as6bpgzqutv" />
    </div>;
}